import { styled } from 'styletron-react';

export const NavigationList = styled('ul', {
  display: `flex`,
  flexDirection: 'column',
  listStyle: `none`,
  padding: 0,
  margin: 0,
});
